export class VerificationDtzFormDto {

  participantNumber: string;
  fullName: string;
  dateOfBirth: string; // yyyy-mm-dd
  examDate: string; // yyyy-mm-dd
  maxListeningAndReadingScore: string;
  maxWritingScore: string;
  maxSpeakingScore: string;
  listeningAndReadingScore: string;
  listeningAndReadingLevel: string;
  writingScore: string;
  writingLevel: string;
  speakingScore: string;
  speakingLevel: string;
  overallResult: string;

  isNtaListening: boolean;
  isNtaReading: boolean;
  isNtaWriting: boolean;
  isNtaSpeaking: boolean;
}
